var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.39 15.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#02ac85;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "time"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M7.7,0a7.7,7.7,0,1,0,7.69,7.7A7.7,7.7,0,0,0,7.7,0ZM11,9.16H7.7a.54.54,0,0,1-.54-.53h0V3.19a.54.54,0,0,1,.54-.53h0a.53.53,0,0,1,.53.53V8.1H11a.53.53,0,0,1,.54.53h0a.54.54,0,0,1-.54.53Z"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.636836abd69e3336f8dc63075311c6eb.svg";
export { ForwardRef as ReactComponent };